import React from 'react';
import TrackerAnchor from '../Tracker/TrackerAnchor'
import {
  File,
  FileName,
  Status,
  FileItemStatuses,
  FileAction,
} from './styles/FileItem.styles';

type FileItemProps = {
  fileName: string;
  retry?: () => void;
  remove: () => void;
  status: string;
};

const getStatusButton = (status: string, remove: any, retry: any) => {
  if (status === FileItemStatuses.warning.name) {
    return (
      <TrackerAnchor onClick={retry}>
        Retry
      </TrackerAnchor>
    )
  }
  if (status !== FileItemStatuses.success.name) {
    return (
      <TrackerAnchor onClick={remove}>
        Remove
      </TrackerAnchor>
    )
  }
  return null;
}

const FileItem = ({
  fileName,
  retry,
  remove,
  status
}: FileItemProps) => (
  <div>
    <File status={status as keyof typeof FileItemStatuses}>
      <FileName>{fileName}</FileName>
      
      <FileAction>
        {getStatusButton(status, remove, retry)}
      </FileAction>
      

      <Status status={status as keyof typeof FileItemStatuses}>
        {status === FileItemStatuses.loading.name && (
          <>
            <div>Uploading...</div>
          </>
        )}
        {status === FileItemStatuses.success.name && 'Uploaded'}
        {status === FileItemStatuses.typeError.name && 'Unsupported File Type'}
        {status === FileItemStatuses.sizeError.name && 'File Too Large'}
        {status === FileItemStatuses.warning.name && 'Upload Failed'}
      </Status>
    </File>
  </div>
);

export default FileItem;